const openMenu = (event) => {
    let open = event.getAttribute("data-open");
    let self = event.nextElementSibling;

    if (open === "false") {
        event.setAttribute("data-open", "true")
        self.style.maxHeight = self.scrollHeight + "px"
    } else {
        event.setAttribute("data-open", "false")
        self.style.maxHeight = 0 + "px"
    }

    
}